module.exports = __webpack_public_path__ + "static/media/contest-form.58297a91.jpg";